import { RestaurantsListHeader } from "./RestaurantsListHeader";

export default RestaurantsListHeader;
